// src/components/Products.js
import React from 'react';
import './Products.css';

// Importa las imágenes locales
import olivoImg from '../images/olivos.jpeg';
import pecanImg from '../images/Pecan.jpg';
import almendraImg from '../images/alemendros.jpg';

// Si no tienes esos nombres exactos, ajusta según tus archivos
// Pueden ser: olivos.jpg, nueces-pecan.jpg, almendras.jpg, etc.

function Products() {
  const products = [
    {
      id: 1,
      title: "Olivos",
      image: olivoImg,
      description: "Cultivamos variedades selectas de olivos para la producción de aceitunas de mesa y aceite de oliva extra virgen de calidad premium.",
      badges: ["Aceitunas verdes", "Aceitunas negras", "Aceite de oliva"],
      className: "product-olive",
      icon: "fas fa-leaf"
    },
    {
      id: 2,
      title: "Pecanes",
      image: pecanImg,
      description: "Nuestros nogales producen nueces de pecan grandes y crujientes, ricas en nutrientes y antioxidantes, perfectas para consumo directo o repostería.",
      badges: ["Nueces enteras", "Medias nueces", "Troceadas"],
      className: "product-pecan",
      icon: "fas fa-seedling"
    },
    {
      id: 3,
      title: "Almendros",
      image: almendraImg,
      description: "Cultivamos almendras de excelente calidad, dulces y nutritivas, ideales para consumo directo, repostería y producción de leche de almendras.",
      badges: ["Almendras naturales", "Almendras tostadas", "Harina de almendra"],
      className: "product-almond",
      icon: "fas fa-tree"
    }
  ];

  return (
    <section id="productos" className="products-section">
      <div className="container">
        <h2 className="section-title">Nuestros Productos</h2>
        <p className="section-subtitle">
          Ofrecemos una selección de productos agrícolas de la más alta calidad, 
          cultivados con esmero y dedicación.
        </p>
        
        <div className="products-container">
          {products.map(product => (
            <div className="product-item-wrapper" key={product.id}>
              <div className={`product-card ${product.className}`}>
                {/* Imagen del producto */}
                <div className="product-image-container">
                  <img 
                    src={product.image} 
                    alt={product.title} 
                    className="product-image"
                  />
                  <div className="product-icon">
                    <i className={product.icon}></i>
                  </div>
                </div>
                
                {/* Contenido del producto */}
                <div className="product-content">
                  <h3 className="product-title">{product.title}</h3>
                  <p className="product-description">{product.description}</p>
                  
                  {/* Badges/etiquetas */}
                  <div className="product-badges">
                    {product.badges.map((badge, index) => (
                      <span key={index} className="product-badge">
                        {badge}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Products;